import { Box, useMediaQuery, Tabs, Tab, Grid, Button, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState, useEffect, lazy, Suspense } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFirestore, useFirebase } from 'react-redux-firebase';
import collections from '../../constants/FirestoreCollections';
import SearchBar from './components/SearchBar';
import ReminderAlert from './components/ReminderAlert';
import { actions } from '../../actions';
import {
  getNotificationsFilters,
  mergeUpdatedOjectsArray,
  sendAndSaveNotificationFilters,
  updateNotificationsWithFilters,
} from './helpers';
import Text from '../../shared/Text';
import { handleErrorSwal, handleSuccesSwal, handleWarningSwal } from '../../shared/swals';

const Specialties = lazy(() => import('./Specialties/Specialties'));
const Professionals = lazy(() => import('./Professionals/Professionals'));
const Insurances = lazy(() => import('./Insurances/Insurances'));
const InsurancesBySpecialties = lazy(() =>
  import('./InsurancesBySpecialties/InsurancesBySpecialties'),
);

const useStyles = (small) => {
  return makeStyles((theme) => ({
    specialtyItem: {
      cursor: 'pointer',
      width: 'fit-content',
      minWidth: '300px',
      maxWidth: '300px', // limitar el ancho máximo del texto
      wordWrap: 'break-word', // permitir que las palabras largas se rompan y pasen a la siguiente línea
    },
  }));
};

export default function Reminders() {
  const profile = useSelector((state) => state.firebase.profile);
  const labelsConfiguration = useSelector((state) => state.app.labelsConfiguration);
  // define styles
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  const appDispatch = useDispatch();
  const firebase = useFirebase();

  // state navtab
  const [value, setValue] = React.useState(0);
  const [search, setSearch] = useState('');
  const [showUpdateButton, setShowUpdateButton] = useState(false);
  const handleChange = (e, newValue) => {
    e && e.preventDefault();
    setValue(newValue);
    setSearch('');
  };

  // hooks
  const organization = useSelector((state) => state.app.organization);
  const [prestobotsConfig, setprestobotsConfig] = useState();
  const [newNotificationsFilters, setNewNotificationsFilters] = useState({});
  const [filtersToUpdate, setNewfiltersToUpdate] = useState({});
  const [chargeComponents, setChargeComponents] = useState(false);
  const [documentId, setDocumentId] = useState('');

  const setChargingModal = (boolean) => {
    return appDispatch({
      type: actions.changeLoading,
      loading: { loading: boolean, priority: 1 },
    });
  };
  const setSnackBar = (message, severity) => {
    return appDispatch({
      type: actions.alert,
      alert: {
        snackbarOpen: true,
        snackbarMessage: message,
        snackbarSeverity: severity,
      },
    });
  };

  const fetchToConfiguration = async (token) => {
    const queryFilters = {
      organizationId: organization.id,
    };

    const response = await getNotificationsFilters(token, queryFilters);
    if (response && response.length > 0) {
      const filtersData = response[0];
      setDocumentId(filtersData.id);
      setNewNotificationsFilters({
        ...filtersData,
      });
      // eslint-disable-next-line no-undef
      localStorage.setItem('newNotificationsFilters', JSON.stringify(filtersData));
    } else {
      console.log('No se encontraron datos para los filtros especificados.');
      setDocumentId('');
      setNewNotificationsFilters({});
      // eslint-disable-next-line no-undef
      localStorage.removeItem('newNotificationsFilters');
    }
  };

  useEffect(() => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    firestore
      .collection(collections.configurations)
      .where('name', '==', 'prestobots')
      .get()
      .then((res) => {
        if (!res.empty) {
          setprestobotsConfig({ id: res.docs[0].id, ...res.docs[0].data() });
        }
      });
    if (organization && organization.id) {
      firebase
        .auth()
        .currentUser.getIdToken(true)
        .then(async (token) => {
          await fetchToConfiguration(token);
          setChargeComponents(true);
        });
    }
  }, [organization]);

  const firestore = useFirestore();

  const updateObjectToSend = (object) => {
    const newObject = {
      ...newNotificationsFilters,
    };

    if (object.professionalsToIgnore) {
      newObject.professionalsToIgnore = object.professionalsToIgnore;

      let updatedValues = [];

      updatedValues = mergeUpdatedOjectsArray(
        filtersToUpdate?.professionalsToIgnore,
        object.professionalsToUpdate.professionalsToIgnore,
      );

      setNewfiltersToUpdate({
        ...filtersToUpdate,
        professionalsToIgnore: updatedValues,
      });
    }
    if (object.specialtiesToIgnore) {
      newObject.specialtiesToIgnore = object?.specialtiesToIgnore;

      let updatedValues = [];

      updatedValues = mergeUpdatedOjectsArray(
        filtersToUpdate?.specialtiesToIgnore,
        object.specialtiesToUpdate?.specialtiesToIgnore,
      );

      setNewfiltersToUpdate({
        ...filtersToUpdate,
        specialtiesToIgnore: updatedValues,
      });
    }
    if (object.insurancesToIgnore) {
      newObject.insurancesToIgnore = object.insurancesToIgnore;

      let updatedValues = [];

      updatedValues = mergeUpdatedOjectsArray(
        filtersToUpdate?.insurancesToIgnore,
        object.insurancesToUpdate.insurancesToIgnore,
      );

      setNewfiltersToUpdate({
        ...filtersToUpdate,
        insurancesToIgnore: updatedValues,
      });
    }
    if (object?.insurancesBySpecialtyToIgnore) {
      newObject.insurancesBySpecialtyToIgnore = object.insurancesBySpecialtyToIgnore;

      let updatedValues = [];

      updatedValues = mergeUpdatedOjectsArray(
        filtersToUpdate?.insurancesBySpecialtyToIgnore,
        object.insurancesBySpecialtyToUpdate.insurancesBySpecialtyToIgnore,
      );

      setNewfiltersToUpdate({
        ...filtersToUpdate,
        insurancesBySpecialtyToIgnore: updatedValues,
      });
    }
    setNewNotificationsFilters(newObject);
    // eslint-disable-next-line no-undef
    localStorage.setItem('newNotificationsFilters', JSON.stringify(newObject));
  };

  const handleUpdate = async () => {
    try {
      setChargingModal(true);

      const token = await firebase.auth().currentUser.getIdToken(true);

      newNotificationsFilters.organizationId = organization.id;
      newNotificationsFilters.name = 'notificationFilters';
      delete newNotificationsFilters.id;

      await sendAndSaveNotificationFilters({
        token,
        documentId,
        organizationId: organization.id,
        profile,
        filtersToUpdate,
      });

      if (documentId === '') await fetchToConfiguration(token);

      await updateNotificationsWithFilters(organization.id);

      setChargingModal(false);
      setNewfiltersToUpdate({});
      handleSuccesSwal('Filtros actualizados exitosamente');
      setShowUpdateButton(false);
    } catch (error) {
      setChargingModal(false);

      if (error?.response?.status) {
        if (error?.response?.status === 409) {
          setShowUpdateButton(true);
          handleWarningSwal(
            `Actualmente se está ejecutando un proceso de actualización de notificaciones, por favor espere unos minutos en intente nuevamente`,
          );
        } else {
          handleErrorSwal();
          setShowUpdateButton(false);
        }
      }
    }
  };
  // methods

  const tabComponents = [
    <Suspense key="specialties" fallback={<div>...</div>}>
      <Specialties
        organization={organization}
        classes={classes}
        search={search}
        setShowUpdateButton={setShowUpdateButton}
        updatedObjectToSend={updateObjectToSend}
        setChargingModal={setChargingModal}
        chargeComponents={chargeComponents}
        setChargeComponents={setChargeComponents}
      />
    </Suspense>,
    <Suspense key="professionals" fallback={<div>...</div>}>
      <Professionals
        organization={organization}
        classes={classes}
        search={search}
        setShowUpdateButton={setShowUpdateButton}
        updatedObjectToSend={updateObjectToSend}
        setChargingModal={setChargingModal}
        setChargeComponents={setChargeComponents}
        handleChange={handleChange}
      />
    </Suspense>,
    <Suspense key="insurances" fallback={<div>...</div>}>
      <Insurances
        organization={organization}
        classes={classes}
        search={search}
        setShowUpdateButton={setShowUpdateButton}
        updatedObjectToSend={updateObjectToSend}
        setSnackBar={setSnackBar}
        setChargingModal={setChargingModal}
        setChargeComponents={setChargeComponents}
        handleChange={handleChange}
      />
    </Suspense>,
    <Suspense key="insurancesBySpecialties" fallback={<div>...</div>}>
      <InsurancesBySpecialties
        organization={organization}
        classes={classes}
        setShowUpdateButton={setShowUpdateButton}
        updatedObjectToSend={updateObjectToSend}
        setChargingModal={setChargingModal}
        setChargeComponents={setChargeComponents}
        handleChange={handleChange}
      />
    </Suspense>,
  ];
  return (
    <Box sx={{ width: '100%', marginLeft: '32px', marginBottom: '32px', marginRight: '32px' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="nav tabs example"
        centered
        TabIndicatorProps={{ style: { background: 'yellow' } }}
      >
        <Tab label="Filtro especialidades" />
        <Tab label="Filtro profesionales" />
        <Tab label="Filtro obras sociales" />
        <Tab label="Filtro obras sociales por especialidad" />
      </Tabs>
      {value === 3 && (
        <Box textAlign="justify" style={{ width: '93%' }}>
          <Typography variant="h6" gutterBottom>
            Consideraciones Importantes:
          </Typography>
          <Text configuration={labelsConfiguration} propName="remindersSpecialtiesByInsurances" />
        </Box>
      )}
      <Grid
        container
        style={{
          marginTop: value === 3 ? '0px' : '32px',
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        {value !== 3 && <SearchBar setSearch={setSearch} search={search} />}
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpdate}
          disabled={!showUpdateButton}
          style={{
            marginLeft: value === 3 ? '0px' : '60px',
            height: '53px',
          }}
        >
          Guardar
        </Button>
      </Grid>
      <Grid container style={{ marginTop: '23px' }}>
        {tabComponents[value]}
      </Grid>
      <Grid container style={{ marginTop: '23px' }}>
        <ReminderAlert prestobotsConfig={prestobotsConfig} organization={organization} />
      </Grid>
    </Box>
  );
}
